// Простой range slider поверх нативного <input type="range">: драг мышью/тачем
// и клавиатура остаются на браузере, JS только красит заполненную часть трека
// и двигает подсказку со значением над ползунком (вид - в
// src/scss/components/_range-slider.scss).
//
// Минимальная разметка:
// <div data-range-slider>
//   <label class="range-slider__label" for="my-range">Заголовок</label>
//   <div class="range-slider__control">
//     <div class="range-slider__tooltip" data-range-slider-tooltip></div>
//     <input type="range" id="my-range" class="range-slider__input"
//            data-range-slider-input min="0" max="100000" step="1000" value="25000">
//   </div>
//   <div class="range-slider__scale">
//     <span class="range-slider__mark" data-range-slider-mark="0">0</span>
//     <span class="range-slider__mark" data-range-slider-mark="100000">100K</span>
//   </div>
// </div>
//
// data-range-slider-suffix на инпуте (например " ₽") дописывается к значению в подсказке.
// Клик по элементу с data-range-slider-mark переставляет слайдер на его значение.

// Должен совпадать с шириной .range-slider__input::-webkit-slider-thumb/-moz-range-thumb
// в src/scss/components/_range-slider.scss.
const THUMB_SIZE = 20;

// Наклон подсказки при движении и пауза перед тем, как она выпрямится обратно
// (transform-origin: bottom center в scss - подсказка "качается" от кончика стрелочки).
const TILT_ANGLE = 10;
const TILT_RESET_DELAY = 150;

const formatValue = ($input, value) => {
    const suffix = $input.dataset.rangeSliderSuffix || "";

    return `${new Intl.NumberFormat("ru-RU").format(value)}${suffix}`;
};

const updateSlider = ($input, $tooltip, state) => {
    const min = Number($input.min) || 0;
    const max = Number($input.max) || 100;
    const value = Number($input.value);
    const percent = max === min ? 0 : ((value - min) / (max - min)) * 100;

    $input.style.setProperty("--range-slider-percent", `${percent}%`);

    if ($tooltip) {
        $tooltip.textContent = formatValue($input, value);

        // Ползунок физически движется не от 0% до 100% ширины трека, а в пределах
        // (thumbSize/2 ... width - thumbSize/2) - иначе он бы вылезал за край.
        // Поправка возвращает центр подсказки на центр ползунка на всех процентах.
        const thumbOffset = THUMB_SIZE * (percent / 100 - 0.5);

        $tooltip.style.left = `calc(${percent}% - ${thumbOffset}px)`;

        // "Эффект опоздания": двигаем вправо - подсказка наклоняется влево (будто
        // отстаёт), и наоборот. direction положительный, когда значение уменьшается.
        const direction = Math.sign(state.previousValue - value);

        if (direction !== 0) {
            $tooltip.style.transform = `translateX(-50%) rotate(${direction * TILT_ANGLE}deg)`;
        }

        state.previousValue = value;

        clearTimeout(state.tiltTimer);
        state.tiltTimer = setTimeout(() => {
            $tooltip.style.transform = "translateX(-50%) rotate(0deg)";
        }, TILT_RESET_DELAY);
    }
};

// Метки шкалы стоят не вплотную друг к другу, а на своей позиции на треке
// (по значению, а не по счёту) - иначе, например, "25K" рисовалась бы
// посередине шкалы 0-100K вместо реальных 25%.
const positionMarks = ($slider, $input) => {
    const min = Number($input.min) || 0;
    const max = Number($input.max) || 100;

    $slider.querySelectorAll("[data-range-slider-mark]").forEach(($mark) => {
        const value = Number($mark.dataset.rangeSliderMark);
        const percent = max === min ? 0 : ((value - min) / (max - min)) * 100;

        $mark.style.left = `${percent}%`;
        // Крайние метки не центрируем - иначе они вылезают за границы трека.
        $mark.style.transform = percent <= 0 ? "translateX(0%)" : percent >= 100 ? "translateX(-100%)" : "translateX(-50%)";

        $mark.addEventListener("click", () => {
            $input.value = value;
            $input.dispatchEvent(new Event("input"));
        });
    });
};

export const rangeSliderInit = () => {
    document.querySelectorAll("[data-range-slider]").forEach(($slider) => {
        const $input = $slider.querySelector("[data-range-slider-input]");

        if (!$input) return;

        const $tooltip = $slider.querySelector("[data-range-slider-tooltip]");
        const state = { previousValue: Number($input.value), tiltTimer: null };
        const update = () => updateSlider($input, $tooltip, state);

        $input.addEventListener("input", update);
        update();

        positionMarks($slider, $input);
    });
};
